module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('carousel', {
    staticClass: "carousel"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "logo"
  }, [_c('webp-image', {
    attrs: {
      "src": "https://cdn.llscdn.com/fe-static/lls-with-tfchina/logo-w215ppgN.png",
      "alt": "logo",
      "width": "100%"
    }
  })], 1), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), (!this.externalChannels) ? _c('touch', {
    staticClass: "start",
    class: {
      active: _vm.open
    },
    attrs: {
      "tag": "button",
      "type": "button"
    },
    on: {
      "tap": _vm.joinTheActivity
    }
  }, [_vm._v(_vm._s(_vm.status))]) : _c('touch', {
    staticClass: "start active",
    on: {
      "tap": _vm.openApp
    }
  }, [_c('open-app', {
    attrs: {
      "download": 'https://a.app.qq.com/o/simple.jsp?pkgname=com.liulishuo.engzo&ckey=CK1381148873550'
    }
  }, [_vm._v("立即参加")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date"
  }, [_vm._v("活动时间："), _c('strong', [_vm._v("2017.11.24 - 2017.12.7")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("参加活动期间，你每学习 "), _c('strong', [_vm._v("5")]), _vm._v(" 分钟，流利说将为美丽中国支教项目农村学生捐赠 "), _c('strong', [_vm._v("1")]), _vm._v(" 节免费人工智能课程")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("感谢「真爱梦想·一扇窗」公益专项基金对本次活动开展的大力支持。")])])
}]}


//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/template-compiler?{"id":"data-v-bf213eb4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Landing.vue
// module id = 212
// module chunks = 1